import React from 'react'
import { Link } from 'react-router-dom'

import './Header.scss'

const authenticatedOptions = (
  <React.Fragment>
    <Link to="/gallery">Gallery</Link>
    <Link to="/pets">Pets</Link>
    <Link to="/account"><i className="fas fa-user-circle"></i></Link>
  </React.Fragment>
)

const unauthenticatedOptions = (
  <React.Fragment>
    <Link to="/sign-up">Sign Up</Link>
    <Link to="/sign-in">Sign In</Link>
  </React.Fragment>
)

const alwaysOptions = (
  <React.Fragment>
    <Link to="/">Home</Link>
  </React.Fragment>
)

const Header = ({ user }) => (
  <header className="main-header">
    <h1 className="logo-b"><i className="fas fa-paw"></i> Pet Portal</h1>
    <nav>
      { user && <span className='user'>Welcome, {user.username}</span>}
      { alwaysOptions }
      { user ? authenticatedOptions : unauthenticatedOptions }
    </nav>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/header/Header.js